import { render, staticRenderFns } from "./CommentSection.vue?vue&type=template&id=be738848&scoped=true"
import script from "./CommentSection.vue?vue&type=script&lang=js"
export * from "./CommentSection.vue?vue&type=script&lang=js"
import style0 from "./styles/comment-section.css?vue&type=style&index=0&id=be738848&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be738848",
  null
  
)

export default component.exports